import { Textarea } from "../ui/textarea";

export function PlaceholderList({ placeholders }) {
  return (
    <div className="rounded-lg border border-stone-200 bg-stone-50/60 p-3" data-testid="sow-email-placeholders">
      <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500 mb-1">Values you can insert</p>
      <p className="text-xs text-stone-500 mb-2">
        Type a value as <code className="bg-white border border-stone-200 rounded px-1">{"{name}"}</code>. Also: <code className="bg-white border border-stone-200 rounded px-1">**bold**</code>,
        a blank line starts a new paragraph, text in [square brackets] is left out when a value inside it is empty, and an empty paragraph is simply dropped.
      </p>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 text-xs text-stone-600">
        {Object.entries(placeholders).map(([k, d]) => (
          <li key={k}><code className="text-[#1B4F8A] bg-white border border-stone-200 rounded px-1">{`{${k}}`}</code> {d}</li>
        ))}
      </ul>
    </div>
  );
}

export function BlocksEditor({ blocks, value, onChange }) {
  const rows = (text) => Math.min(10, Math.max(2, Math.ceil((text || "").length / 95) + (text || "").split("\n").length - 1));
  return (
    <div className="flex flex-col gap-3" data-testid="sow-email-blocks">
      <p className="font-medium text-sm text-stone-800">Wording <span className="font-normal text-stone-500">· in the order it appears; the facts table and the button are added automatically</span></p>
      {blocks.map((b) => (
        <label key={b.key} className="flex flex-col gap-1 text-sm">
          <span className="text-xs text-stone-600">
            {b.label}
            {b.when && <span className="ml-2 text-[11px] text-sky-800 bg-sky-50 border border-sky-200 rounded-full px-2 py-0.5">{b.when}</span>}
          </span>
          <Textarea value={value[b.key] ?? ""} rows={rows(value[b.key])} onChange={(e) => onChange(b.key, e.target.value)}
            className="font-[inherit] text-sm leading-relaxed" data-testid={`sow-email-block-${b.key}`} />
        </label>
      ))}
    </div>
  );
}
